import Vue from 'vue'
import Vuex from 'vuex'
import { DB } from '@/firebase/db';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loggedIn: false,
    Activated: false,
    loginDialog: false,
    registerDialog: false,
    snackState: false,
    snackText: '',
    userData: null,
    viewedLodges: [],
    unreadNotification: 0,
    aboutDialog: false,
    howItWorks: false,
    movageDialog: false,
    lodgeViewRoute: 0,
    dialogPay: false,
    features: [
        'Fast Internet',
        'Parking Space',
        'Security',
        'Gym',
        'Drainage System',
        'Street Light',
        'Big Compound',
        'Kitchen',
        'Balcony',
        'Wardrope',
        'Iron Doors',
        'Gateman',
        'Lodge Generator',
        'Borehole',
        'Prepaid meter',
        'Constant Water Supply'
    ],
  	inputRules: [
          v => (v && v.length >= 1) || 'This Field is required!'
      ],
    mobileRules: [
          v => (v && v.length >= 1) || 'This Field is required!',
          v => Number.isInteger(Math.abs(v)) || 'Phone number must follow the format: "0705*******"',
          v => (v && v.length === 11) || 'Mobile Number should be 11 digits!'
      ],
    pwdRules: [
          v => (v && v.length !== '' && v.length >= 6) || 'Minimum length is 6  characters'
      ],
    userNameRules: [
          v => (v && v.length !== '' && v.length >= 3) || 'Minimum length is 3  characters'
      ],
    emailRules: [
          v => (v && v.length !== '' && v.length >= 1) || 'E-mail is required',
          v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
    totalLodges: 0
  },
  getters: {
    
  },
  mutations: {
    setSnackText: (state, payload) => {
      state.snackText = payload
      state.snackState = true
    },
    setUserState: (state, payload) => {
      state.loggedIn = payload
    },
    setUserData: (state, payload) => {
      state.userData = payload
    },
    addViewed: (state, payload) => {
      state.viewedLodges.push(payload)
    },
    setNoteCount: (state, payload) => {
      state.unreadNotification = payload
    }
  },
  actions: {
    setSnackText: (context, payload) => {
      context.commit('setSnackText', payload)
    },
    setSnackState: (context, payload) => {
      context.commit('setSnackState', payload)
    },
    setUserState: (context, payload) => {
      context.commit('setUserState', payload)
    },
    setUserData: (context, payload) => {
      context.commit('setUserData', payload)
    },
    syncUserData: (context) => {
      // Syncs user's data with firestore
      var docRef = DB.collection("users").doc(context.state.userData.uid);
      docRef.get().then((doc) => {
          if (doc.exists) {
            // Updates user's data when it is retrived
            context.commit('setUserData', doc.data())
          }
      })
    },
    addViewed: (context, payload) => {
      context.commit('addViewed', payload)
    },
    setNoteCount: (context, payload) => {
      context.commit('setNoteCount', payload)
    }
  }
})
